module.exports = {"410702001":"西街街道","410702002":"东街街道","410702003":"渠东街道","410702007":"文化街街道","410702009":"向阳小区街道","410702100":"洪门镇","410702101":"小店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410702.json
// module id = 1582
// module chunks = 0